var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.3927C8.9085 16.3927 8.81625 16.3722 8.7315 16.328C8.529 16.2244 8.4 16.0135 8.4 15.7835V4.81735C8.4 4.58736 8.52825 4.3749 8.7315 4.27285C8.93475 4.1708 9.17775 4.19213 9.36 4.32996L16.56 9.81304C16.7115 9.92727 16.8 10.1093 16.8 10.3004C16.8 10.4916 16.7115 10.6736 16.56 10.7878L9.36 16.2709C9.25425 16.3516 9.1275 16.3927 9 16.3927ZM9.6 6.03581V14.565L15.2003 10.3004L9.6 6.03581ZM23.4 0.552734H0.6C0.2685 0.552734 0 0.825365 0 1.16197V19.4389C0 19.7755 0.2685 20.0481 0.6 20.0481H23.4C23.7315 20.0481 24 19.7755 24 19.4389V1.16197C24 0.825365 23.7315 0.552734 23.4 0.552734ZM3.6 11.5189H1.2V9.08196H3.6V11.5189ZM3.6 7.8635H1.2V5.42658H3.6V7.8635ZM1.2 12.7374H3.6V15.1743H1.2V12.7374ZM4.8 1.7712H19.2V18.8297H4.8V1.7712ZM20.4 9.08196H22.8V11.5189H20.4V9.08196ZM20.4 7.8635V5.42658H22.8V7.8635H20.4ZM20.4 12.7374H22.8V15.1743H20.4V12.7374ZM22.8 4.20812H20.4V1.7712H22.8V4.20812ZM3.6 1.7712V4.20812H1.2V1.7712H3.6ZM1.2 16.3927H3.6V18.8297H1.2V16.3927ZM20.4 18.8297V16.3927H22.8V18.8297H20.4Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.23582a491addc4ff35b192e6b0d1c392.svg";
export { ForwardRef as ReactComponent };